/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import { colors } from '../../../../../config/theme'
import { createUseStyles } from 'react-jss'
import { ReactComponent as IconRemove } from '../../../../../assets/icons/IconRemove.svg';

const useStyles = createUseStyles({
  filterContainer: {
    width: '45%',
    height: "300px",
    margin: '10px',
    border: `1px solid ${colors.lightGray}`
  },
  listMainClass: {
    width: '100%',
    backgroundColor: colors.white,
    height: '83%',
    overflowY: 'auto',
    '& li:nth-child(odd)': {
      backgroundColor: colors.white
    },
    '& li:nth-child(even)': {
      backgroundColor: colors.lightestGray
    }
  },
  selectedListClass: {
    height: '100%',
  },
  listItemLabel: {
    display: 'inline-block',
    paddingLeft: '4px'
  },
  firstBox: {
    height: '100%',
    width: '100%',
    borderRadius: '2px'
  },
  searchBoxContainer: {
    width: '100%',
    padding: '10px',
    backgroundColor: colors.lightestGray
  },
  searchBox: {
    width: '95%',
    backgroundColor: `${colors.white} !important`,
    borderRadius: '30px',
    border: `1px solid ${colors.lightGray}  !important`,
    // padding: '5px 10px 5px 10px'
    padding: '5px 5px 5px 10px !important',
    fontSize: '15px !important',
  },
  removeIconContainer: {
    position: "relative",
    padding: '5px',
    marginBottom: '0',
    cursor: 'pointer'
  },
  removeIcon: {
    position: 'absolute',
    width: '1em',
    height: '1em',
    opacity: 0
  },
  svgIcon: {
    cursor: 'pointer',
    width: '20px',
    height: '20px'
  },
  removeIconLabel: {
    verticalAlign: 'text-bottom',
    paddingLeft: '10px'
  },
  matchNotFound: {
    position: 'relative',
    textAlign: 'center',
    top: '40%'
  }
})

export default useStyles
